import chatMixin from "../../../mixins/chats";
import UserAvatar from '@/components/UserAvatar';
import moment from "moment";

export default {
  name: "ConversationHeader",
  mixins: [
    chatMixin
  ],
  props: {
    activeMenuBasedOnSelectedChat: {
      type: Array,
      default: () => []
    },
    onClickSelectedParticipantChatMenu: {
      type: Function,
      default: () => {
      }
    },
    onClickSelectedChatMenu: {
      type: Function,
      default: () => {
      }
    },
    item: Object,
    messages: Array,
    showSearchResults: Boolean,
    searchResults: Array,
    currentResultIndex: Number,
    previousResult: Function,
    nextResult: Function,
  },
  watch: {
    item: {
      handler() {
        if (!this.item) return;
        this.currentMenu = this.item.is_group ? this.item.isMute ? this.activeMenuGroupUnMute : this.activeMenuGroup : this.item.isMute ? this.activeMenuUnMute : this.activeMenu;
      },
      deep: true,
      immediate: true
    },
    searchText() {
      this.emitFilteredMessages();
    },
    showChatFilter() {
      if (!this.showChatFilter) {
        this.resetFilters();
      }
    },
  },
  components: {
    UserAvatar
  },
  data() {
    return {
      searchText:"",
      selectedFilters: [],
      filterAvailable: [
        {id: 'address', label: '#address'},
        {id: 'event', label: '#event'},
        {id: 'update', label: '#update'},
        {id: 'contact', label: '#contact'},
        {id: 'ontheway', label: '#ontheway'},
        {id: 'invoice', label: '#invoice'},
        {id: 'video', label: '#video'},
        {id: 'photo', label: '#photo'},
        {id: 'doc', label: '#document'},
        {id: 'media', label: '#media'}
      ],
      showChatFilter: false,
      showFilterDropdown: false,
      currentMenu: [],
      activeMenuGroup: [
        {title: 'Add Participant'},
        {title: 'Remove Participant'},
        {title: 'Leave Group'},
        {title: 'Mute Group'},
        {title: 'Re-name Group'},
        {title: 'Change Group Photo'},
        {title: 'Delete Group'},
      ],
      activeMenuGroupUnMute: [
        {title: 'Add Participant'},
        {title: 'Remove Participant'},
        {title: 'Leave Group'},
        {title: 'Unmute Group'},
        {title: 'Re-name Group'},
        {title: 'Change Group Photo'},
        {title: 'Delete Group'},
      ],
      activeMenu: [
        {title: 'Mute Chat'},
        {title: 'Delete Chat'},
      ],
      activeMenuUnMute: [
        {title: 'Unmute Chat'},
        {title: 'Delete Chat'},
      ]
    }
  },
  computed: {
    // Presence ("last seen") for the other participant of a 1-on-1 chat.
    // Gated to the vendor role to mirror iOS, which only shows the presence
    // subtitle for vendors. `this.user` comes from the chats mixin and is
    // refreshed from uxDocs (which carries last_connection) on every update.
    presence_other_is_vendor() {
      return !!(this.user && this.user.user_role === 'vendor' && this.item && !this.item.is_group);
    },
    presence_last_connection() {
      return this.user ? this.user.last_connection : undefined;
    },
    presence_is_active() {
      // 0 is the "Active now" sentinel written by the presence endpoint / mobile.
      return this.presence_last_connection === 0;
    },
    presence_text() {
      if (!this.presence_other_is_vendor) return '';
      const v = this.presence_last_connection;
      if (v === undefined || v === null) return '';
      if (v === 0) return 'Active now';
      return 'Last seen ' + moment(v * 1000).fromNow();
    },
    filteredMessages() {
      if (!this.messages) return [];

      return this.messages.filter(msg => {
        // Verificar si coincide con el texto de bsqueda
        const messageText = (msg.text || msg.content || '').toLowerCase();
        const searchLower = (this.searchText || '').toLowerCase().trim();
        
        const matchesText = !searchLower || messageText.includes(searchLower);
        
        // Verificar si coincide con los filtros seleccionados
        const matchesFilter = this.selectedFilters.length === 0 || 
          this.selectedFilters.includes(msg.type) ||
          (msg.media && this.selectedFilters.includes(msg.media.file_subtype));
        
        return matchesText && matchesFilter;
      });
    }
  },
  methods: {
    emitFilteredMessages() {
      this.$emit('selectedFilters', {
        filters: this.selectedFilters,
        searchText: this.searchText
      });
    },
    toggleFilter(id) {
      const idx = this.selectedFilters.indexOf(id);
      if (idx > -1) {
        this.selectedFilters.splice(idx, 1);
      } else {
        this.selectedFilters.push(id);
      }
      this.emitFilteredMessages();
    },
    resetFilters() {
      this.showChatFilter = false;
      this.showFilterDropdown = false;
      this.selectedFilters = [];
      this.searchText = "";
      this.$emit('selectedFilters', {
        filters: [],
        searchText: ""
      });
    },
    selectConversation(item) {
      this.selectedConversation(item);
    },
    check_messages(item, callback) {
      const self = this;
      if (item.chat_id) {
        self.messagesButtomOfPage = true;
        self.ignoreMessagesScrollEvent = true;
        self.get_messages({
          chat_id: item.chat_id,
          phone: self.owner_id,
          empty: true,
          chat: item
        }).then(() => {
          callback ? callback() : "";
          self.scrollable("vs", "100%");

          const messagesWindow = document.querySelector(".messages-scroll .scroll > .__panel");
          messagesWindow.removeEventListener('mousewheel', self.handleScrollMessages);
          messagesWindow.removeEventListener('onmousewheel', self.handleScrollMessages);
          messagesWindow.removeEventListener('DOMMouseScroll', self.handleScrollMessages);
          messagesWindow.addEventListener('mousewheel', self.handleScrollMessages);
          messagesWindow.addEventListener('onmousewheel', self.handleScrollMessages);
          messagesWindow.addEventListener('DOMMouseScroll', self.handleScrollMessages);

          self.calculateUnreadCountersPosition();
        });
      } else {
        self.get_messages({}).then(() => {
          self.scrollable("vs", "100%");
        });
      }

    },
  }
};
